import { Avatar } from "antd";
import React from "react";

export default function Events({ VenuesDetails }) {
  return (
    <div className="details-section" style={{boxShadow:"0 0 5px 0 rgba(0,0,0,0.1)", background:"white", padding:"20px"}}>
      <h4>Events We Do</h4>

      <div className="row" style={{ marginTop: 20 }}>
        {VenuesDetails?.eventcommunities?.map((val, index) => (
          <div className="col-md-3" key={index}>
            <p className="d-flex align-items-center">
              <Avatar shape="square" src={val?.image} size={30} />
              <strong style={{ marginLeft: 5 }}>{val?.name}</strong>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
